<p-dialog class="acv-modal" [modal]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [visible]="visibility" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ width: '70%', height: '50vh' }">
    <ng-template pTemplate="header">
      <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
        <h4 class="font-poppin text-color-grey4 flex gap-2">
            <span class="font-bold">{{title}}</span>
            <span>({{ date | dateTime }})</span>
        </h4>
        <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
      </div>
    </ng-template>
  
    <ng-template pTemplate="content">
      <p-timeline [value]="getDetails()" class="w-full md:w-20rem mt-3">
        <ng-template pTemplate="content" let-event>
            <div class="flex flex-row">
                <h5 class="font-poppin fw-500">{{event.title}}</h5>
            </div>
            <div class="grid mt-3">
                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Leg Name</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2" style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ legName || event.leg_name || '-' }}
                    </p>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Start Date & Time</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2" style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.started_at | dateTime : false }}
                    </p>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">End Date & Time</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.completed_at | dateTime : false }}
                    </p>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Actual Start Date & Time</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.actual_started_at | dateTime : false }}
                    </p>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Actual End Date & Time</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.actual_completed_at | dateTime : false }}
                    </p>
                </div>
                <!-- for only log type 8 (Trip assignment updated) -->
                <div *ngIf="logType === 8" class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Origin</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.origin || '-' }}
                    </p>
                </div>
                <!-- for only log type 8 (Trip assignment updated) -->
                <div *ngIf="logType === 8" class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Destination</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.destination || '-' }}
                    </p>
                </div>
                
                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Truck</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event?.truck?.truck_no || (event?.truck_name || '-') }}
                    </p>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Driver</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event?.driver?.name || (event?.driver_name || '-') }}
                    </p>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Trailer</p>
                    <a class="fs-14 fw-500 font-poppin text-color-black2 mt-2">
                        {{ event?.trailer?.trailer_no || (event?.trailer_name || '-') }}
                    </a>
                </div>

                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Status</p>
                    <button style="cursor: default" pButton [attr.status]="event.status" type="button"
                        class="btn-status p-button-outlined mt-2">
                        {{ event.status || "-" }}
                    </button>
                </div>

                <div *ngIf="event.exception_code" class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Exception Code</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.exception_code }}
                    </p>
                </div>

                <div *ngIf="event.exception_description" class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Exception Description</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event.exception_description }}
                    </p>
                </div>
                
                <div class="col-12 md:col-3 lg:col-3 xl:col-3 mb-3">
                    <p class="fs-14 fw-400 font-poppin text-color-grey4">Special Instructions</p>
                    <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2"
                        style="word-wrap: break-word; overflow-wrap: break-word;">
                        {{ event?.special_instructions ||  '-' }}
                    </p>
                </div>
            </div>
        </ng-template>
    </p-timeline>
    </ng-template>
  </p-dialog>
  